export enum EEnergySourceType {
  SOLAR_PV = "SOLAR_PV",
  GRID = "GRID",
  GENERATOR = "GENERATOR",
  BATTERY = "BATTERY",
  WIND_TURBINE = "WIND_TURBINE",
}
